<div class="container white-bg mr-xsmall-b border rounded-large" *ngIf="marketingConsentType$ | async">
  <fin-expander-card
    [expandOpen]="marketingConsentOpen"
    [iconName]="SvgLibraryIcon.MAGAZINES_BLOCK"
    [iconClasses]="marketingConsentOpen ? 'nordic-blue-900-text' : 'nordic-blue-50-text'"
    [title]="'paxDetails.marketingConsent.title' | finLocalization"
    [capitalizeTitle]="false"
    (expandChange)="marketingConsentOpen = !$event"
    [attr.data-testid]="'marketing-consent'"
  >
    <ng-container ngProjectAs="expandedContent">
      <div class="flex ps-medium" *ngIf="marketingConsentType$ | async as marketingConsentType">
        <ng-container
          [ngTemplateOutlet]="
            marketingConsentType === MarketingConsentType.NEWSLETTER ? newsletterContent : marketingConsentContent
          "
          [ngTemplateOutletContext]="{ marketingConsentType: marketingConsentType }"
        ></ng-container>
      </div>
    </ng-container>
  </fin-expander-card>
</div>

<ng-template #newsletterContent>
  <div class="flex flex--column font-body-1">
    <div class="ms-small-b">
      {{ 'paxDetails.marketingConsent.flightOffersDescription' | finLocalization }}
    </div>
    <form [formGroup]="formGroup">
      <fcom-checkbox class="block ms-xsmall-b" [formGroup]="formGroup" [formControlName]="'marketingNewsletter'">
        <span>{{ 'paxDetails.marketingConsent.signUpMarketingNewsletter' | finLocalization }}</span>
      </fcom-checkbox>
      <fcom-checkbox [formGroup]="formGroup" [formControlName]="'advertising'">
        <span>{{ 'paxDetails.marketingConsent.signUpAnalytics' | finLocalization }}</span>
      </fcom-checkbox>
    </form>
    <span
      class="font-body-2 regular-type block ms-xsmall-t"
      [innerHTML]="'newsletterSignUpForm.formDetails.newsLetterTerms' | finLocalization | finSafe: 'html'"
    ></span>
  </div>
</ng-template>

<ng-template #marketingConsentContent let-marketingConsentType="marketingConsentType">
  <fcom-checkbox #consentCheck></fcom-checkbox>
  <div>
    <span class="font-body-1 medium-type">
      {{
        (marketingConsentType === MarketingConsentType.MEMBER_OFFERS
          ? 'paxDetails.marketingConsent.memberOffers'
          : 'paxDetails.marketingConsent.flightOffers'
        ) | finLocalization
      }}
    </span>
    <span
      class="font-body-2 regular-type block ms-xxsmall-t"
      [innerHTML]="'paxDetails.marketingConsent.privacyPolicy' | finLocalization | finSafe: 'html'"
    ></span>
  </div>
</ng-template>
